import React from 'react';

/**
 * Spinner brandeado PUJA — usa el iso oficial (SVG inline) con pulso suave.
 *
 * Uso:
 *   <PujaSpinner />                       // tamaño default (centrado)
 *   <PujaSpinner size="lg" />             // grande
 *   <PujaSpinner size="sm" inline />      // chico, sin centrar
 *
 * Props:
 *   size: 'sm' | 'md' | 'lg'  (default 'md')
 *   inline: boolean — si true no aplica padding/centrado del contenedor
 *   label: string opcional debajo del iso
 *
 * El SVG esta inline (1.5KB) para evitar HTTP round-trip y porque es asset
 * de identidad criticamente brandeado. Colores fijos del manual de marca:
 *   #b5996e (dorado puja) + #fefefe (blanco).
 */
const PujaIsoSvg = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 506.7 467.18"
    width={size}
    height={(size * 467.18) / 506.7}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill="#b5996e"
      d="M137.61,401.99c-53.99-33.87-69.31-109.32-34.86-162.12,10.98-16.82,24.65-30.9,41.84-39.2,16.29-7.85,31.84-13.36,50.16-14.51l.79-31.77c.45-17.85,6.71-32.98,15.41-48.25,22.46-39.38,63.99-62.45,108.8-60.24,44.57,2.2,83.66,29.69,102.75,71.57,17.63,40.06,11.91,87.84-16.42,121.37-22.16,26.23-51.21,40.9-84.98,44.51,5.08,47.25-13.19,94.35-51.83,118.28-41.53,25.72-89.28,26.97-131.68.36ZM211.01,374.05c34.39-4.09,62.53-32.7,62.78-66.93l1.03-143.11c.17-24.03,24.08-41.17,46.72-39.53l.37,111.07c23.11-2.53,41.89-16.13,53.81-35.87,15.15-25.09,11.64-59.35-7.85-80.71-30.75-33.71-78.85-32.44-109.17.98-10.9,12.02-16.08,28.5-16.09,45.76l-.08,141.11c-4.78,21.97-24.69,37.32-47.37,35.86l-.15-109.66c-8.99,2.03-17,3.13-25.11,7.05-30.16,14.59-44.87,51.69-34.78,83.55,9.98,31.5,40.15,54.67,75.88,50.42Z"
    />
    <path
      fill="#fefefe"
      d="M211.01,374.05c-35.73,4.25-65.9-18.93-75.88-50.42-10.09-31.86,4.61-68.96,34.78-83.55,8.12-3.92,16.13-5.03,25.11-7.05l.15,109.66c22.68,1.46,42.59-13.9,47.37-35.86l.08-141.11c0-17.27,5.18-33.75,16.09-45.76,30.32-33.42,78.42-34.69,109.17-.98,19.49,21.36,23,55.62,7.85,80.71-11.92,19.74-30.71,33.34-53.81,35.87l-.37-111.07c-22.65-1.64-46.55,15.5-46.72,39.53l-1.03,143.11c-.25,34.23-28.39,62.84-62.78,66.93Z"
    />
  </svg>
);

/**
 * `fondo` pinta el bloque del loader. Por defecto va transparente, que es lo
 * correcto en el panel: ahi el gris perla del body ES el fondo de la pantalla.
 *
 * El micrositio le pasa blanco porque ahi el perla desentona: mientras carga se
 * ve todo gris y al terminar la pagina queda blanca, asi que el visitante ve un
 * cambio de color en cada navegacion. Se nota mucho mas desde que el iframe se
 * ajusta al contenido, porque el bloque gris ocupa el alto completo.
 */
const PujaSpinner = ({ size = 'md', inline = false, label, fondo }) => {
  const isoSize = size === 'sm' ? 36 : size === 'lg' ? 96 : 64;
  const padding = inline ? 0 : '80px 0';

  return (
    <div
      className="puja-spinner"
      style={{ textAlign: 'center', padding, background: fondo }}
      role="status"
      aria-live="polite"
      aria-label={label || 'Cargando'}
    >
      <style>{`
        @keyframes puja-spinner-pulse {
          0%, 100% { opacity: 0.45; transform: scale(0.96); }
          50%      { opacity: 1;    transform: scale(1); }
        }
        .puja-spinner__iso {
          display: inline-block;
          animation: puja-spinner-pulse 1.4s ease-in-out infinite;
        }
        .puja-spinner__label {
          margin-top: 14px;
          font-family: 'Montserrat', sans-serif;
          font-size: 12px;
          color: #999;
          letter-spacing: 0.5px;
        }
      `}</style>
      <div className="puja-spinner__iso">
        <PujaIsoSvg size={isoSize} />
      </div>
      {label && <div className="puja-spinner__label">{label}</div>}
    </div>
  );
};

export default PujaSpinner;
